module.exports = __webpack_public_path__ + "static/media/xuefinish.d46acc69.mp3";